import { Box } from "@mui/material";
import Markdown from "react-markdown";
import { useTheme } from "@mui/material/styles";

interface StyledMarkdownProps {
  children: string | null | undefined;
}

function StyledMarkdown({ children }: StyledMarkdownProps) {
  const theme = useTheme();
  const vibrantColor = theme.palette.primary.vibrant;

  return (
    <Box
      sx={{
        fontSize: "13px",
        "& ul, & ol": {
          paddingLeft: 2,
          margin: 0,
          marginBottom: 1,
          "&:last-child": {
            marginBottom: 0,
          },
        },
        "& li": {
          fontSize: "13px",
          marginBottom: 0.5,
          position: "relative",
          paddingLeft: 2,
          listStyle: "none",
          "&::before": {
            content: '"✓"',
            position: "absolute",
            left: 0,
            color: vibrantColor,
            fontWeight: "bold",
          },
          "&:last-child": {
            marginBottom: 0,
          },
        },
      }}
    >
      <Markdown>{children}</Markdown>
    </Box>
  );
}

export default StyledMarkdown;

